export var RESELLERS_LIST_PATH = '/resellers/';
export var RESELLER_ORGANIZATIONS_LIST_PATH = '/resellers/:resellerId/organizations/';
